import script from "./transactions.vue?vue&type=script&setup=true&lang=js"
export * from "./transactions.vue?vue&type=script&setup=true&lang=js"

import "./transactions.vue?vue&type=style&index=0&id=12bda022&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12bda022"]])

export default __exports__